import React, { useState, useEffect } from 'react';
import './PWAInstallPrompt.css';

const PWAInstallPrompt = ({ isOpen, onClose }) => {
  const [deviceType, setDeviceType] = useState('');
  const [browserType, setBrowserType] = useState('');

  useEffect(() => {
    // Detect device and browser
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /ipad|iphone|ipod/.test(userAgent);
    const isAndroid = /android/.test(userAgent);
    const isChrome = /chrome/.test(userAgent) && !/edg/.test(userAgent);
    const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
    const isFirefox = /firefox/.test(userAgent);

    if (isIOS) {
      setDeviceType('ios');
      setBrowserType(isSafari ? 'safari' : 'other');
    } else if (isAndroid) {
      setDeviceType('android');
      setBrowserType(isChrome ? 'chrome' : isFirefox ? 'firefox' : 'other');
    } else {
      setDeviceType('desktop');
      setBrowserType('unsupported');
    }
  }, []);

  const getInstallInstructions = () => {
    if (deviceType === 'ios' && browserType === 'safari') {
      return {
        title: 'Install Hebron App',
        steps: [
          { text: '1. Tap the Share button', icon: '↗', detail: 'Located at the bottom of Safari' },
          { text: '2. Scroll down and tap "Add to Home Screen"', icon: '+', detail: 'Look for the home screen icon' },
          { text: '3. Tap "Add" to install', icon: '✓', detail: 'The app will appear on your home screen' }
        ],
        note: 'The app will work offline and feel like a native app!'
      };
    } else if (deviceType === 'android' && browserType === 'chrome') {
      return {
        title: 'Install Hebron App',
        steps: [
          { text: '1. Tap the Menu button', icon: '⋮', detail: 'Located in the top-right corner' },
          { text: '2. Select "Add to Home screen"', icon: '+', detail: 'Or "Install app" if available' },
          { text: '3. Tap "Add" or "Install"', icon: '✓', detail: 'The app will be added to your home screen' }
        ],
        note: 'You can also look for an install banner at the bottom of the screen!'
      };
    } else if (deviceType === 'android') {
      return {
        title: 'Install Hebron App',
        steps: [
          { text: '1. Open the browser menu', icon: '☰', detail: 'Usually three lines or dots' },
          { text: '2. Look for "Add to Home Screen"', icon: '+', detail: 'May be under "Page" or "Site" options' },
          { text: '3. Confirm the installation', icon: '✓', detail: 'The app will appear on your home screen' }
        ],
        note: 'Steps may vary slightly depending on your browser.'
      };
    } else {
      // Desktop - not supported
      return null;
    }
  };

  const instructions = getInstallInstructions();

  if (!isOpen || !instructions) return null;

  return (
    <div className="pwa-install-overlay">
      <div className="pwa-install-modal">
        <div className="pwa-install-header">
          <h3>{instructions.title}</h3>
          <button className="pwa-install-close" onClick={onClose}>×</button>
        </div>

        <div className="pwa-install-content">
          <div className="pwa-install-icon">
            APP
          </div>

          <p className="pwa-install-description">
            Install Hebron as an app on your device for the best experience!
          </p>

          <div className="pwa-install-steps">
            {instructions.steps.map((step, index) => (
              <div key={index} className="pwa-install-step">
                <div className="pwa-install-step-icon">{step.icon}</div>
                <div className="pwa-install-step-content">
                  <div className="pwa-install-step-text">{step.text}</div>
                  <div className="pwa-install-step-detail">{step.detail}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="pwa-install-note">
            {instructions.note}
          </div>
        </div>

        <div className="pwa-install-footer">
          <button className="pwa-install-button" onClick={onClose}>
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;